import React, { useState, useMemo, useRef } from "react";

import BulkRequestZipDocumentTable from "../../../../../bulk/request/zip/document/table";
import { fetchCustomFieldValue } from "../../../../../helper/custom_field/helper"
import { getByIds as getLaboralHiringDocumentByIds } from "../../../../../laboral/hiring_document/axios";
import { create } from "../../../../../laboral/bulk/request/zip/document/axios";

const LaboralBulkRequestZipDocumentForm = props => {
  const {
    customFields
  } = props;
  const { companies, documentTypes, aasmStates, securityLayers } = props?.filters;
  const { currentCustomer, currentUser } = props;
  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest);
  const hiringStateOptions = [{ value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired') }]

  const dataTableSecurityLayerColumns = useMemo(() => {
    if (currentCustomer.security_layer && securityLayers?.length > 0) {
      return {
        field: 'entity.employee.security_layer.name',
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.entity.employee?.security_layer?.name || I18n.t('no_entry'),
        filter: {
          enabled: true,
          placeholder: 'Seleccione una capa de seguridad',
          inputType: 'simple_select',
          options: _.map(securityLayers, securityLayer => ({
            value: securityLayer.id,
            label: securityLayer.name,
          })),
          filterrific: {
            search: 'by_employee_security_layer_id'
          }
        }
      }
    }
  })

  const dataTableDefaultColumns = [
    {
      field: 'entity.company.company_config.name',
      header: I18n.t("activerecord.attributes.laboral/hiring.company"),
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_company',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'company_name_'
        }
      }
    },
    {
      field: 'entity.employee.identifier',
      header: I18n.t("activerecord.attributes.laboral/employee.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador del empleado',
        filterrific: {
          search: 'search_by_employee_identifier'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_identifier_'
        }
      }
    },
    {
      field: "entity.employee.employee_config.email",
      header: I18n.t("activerecord.attributes.laboral/hiring.employee_email"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el correo electrónico del ${I18n.t(
          "activerecord.attributes.laboral/hiring.employee"
        )}`,
        filterrific: {
          search: "search_by_employee_email"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_email_'
        }
      }
    },
    {
      field: "entity.employee.employee_config.name",
      header: I18n.t("activerecord.attributes.laboral/hiring.employee"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el nombre del ${I18n.t(
          "activerecord.attributes.laboral/hiring.employee"
        )}`,
        filterrific: {
          search: "search_by_employee_name"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_name_'
        }
      }
    },
    {
      field: "entity.identifier",
      header: I18n.t("activerecord.attributes.laboral/hiring.identifier"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el idenficador del ${I18n.t(
          "activerecord.attributes.laboral/hiring"
        )}`,
        filterrific: {
          search: "search_by_hiring_identifier"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'hiring_identifier_'
        }
      }
    },
    {
      field: "entity.active_to_s",
      header: `Estado de Contratación`,
      filter: {
        enabled: true,
        placeholder: `Seleccione un estado de contratación`,
        inputType: 'simple_select',
        options: hiringStateOptions,
        filterrific: {
          search: "by_hiring_state"
        }
      },
    },
    {
      field: "entity.start_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.start_date")}`,
      filter: {
        enabled: true,
        placeholder: `Ingrese la ${I18n.t(
          "activerecord.attributes.laboral/hiring.start_date"
        )}`,
        filterrific: {
          search: "search_by_hiring_start_date"
        }
      },
    },
    {
      field: "entity.end_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.end_date")}`,
      filter: {
        enabled: true,
        placeholder: `Ingrese la ${I18n.t(
          "activerecord.attributes.laboral/hiring.end_date"
        )}`,
        filterrific: {
          search: "search_by_hiring_end_date"
        }
      },
    },
    {
      field: "label",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.label"),
      filter: {
        enabled: true,
        placeholder: `Ingrese ${I18n.t("activerecord.attributes.laboral/hiring_document.label")}`,
        filterrific: {
          search: "search_by_label"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "label_"
        }
      }
    },
    {
      field: "document_type.name",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.document_type"),
      filter: {
        enabled: true,
        placeholder: `Ingrese ${I18n.t("activerecord.attributes.laboral/hiring_document.label")}`,
        inputType: 'simple_select',
        options: _.map(documentTypes, document_type => ({
          value: document_type.id,
          label: document_type.name,
        })),
        filterrific: {
          search: "by_document_type"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "document_type_name_"
        }
      }
    },
    {
      field: "created_at_to_s",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.created_at"),
      filter: {
        enabled: true,
        placeholder: `Ingrese la ${I18n.t(
          "activerecord.attributes.laboral/hiring_document.created_at"
        )}`,
        filterrific: {
          search: "search_by_created_at"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "created_at_to_s_"
        }
      }
    },
    {
      field: "aasm_state",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.aasm_state.one"),
      body: (row) => I18n.t(`activerecord.attributes.laboral/hiring_document.aasm_state.${row.aasm_state}`),
      filter: {
        enabled: true,
        placeholder: `Seleccione un estado`,
        inputType: 'simple_select',
        options: aasmStates,
        filterrific: {
          search: "by_aasm_state"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "aasm_state_"
        }
      }
    }
  ]

  const dataTableCustomFieldsColumns = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `entity.custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${_.capitalize(customField.label)}`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const hiringDocumentsColumns = useMemo(() => {
    let columns = _.concat(
      dataTableSecurityLayerColumns,
      dataTableDefaultColumns,
      dataTableCustomFieldsColumns
    )

    return _.compact(columns)
  }, [])


  const tableConfirmDocument = (documents, drawDeleteSelectedDocument) => {
    return (
      <div className="d-flex">
        <table className="table mt-2 table-responsive-md">
          <thead>
            <tr>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.company")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.employee")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring_document.document_type")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.start_date")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.end_date")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.delete")}
              </th>
            </tr>
          </thead>
          <tbody>
            {_.map(documents, function (document, index) {
              return (
                <tr key={`tr-list-documents-${document.id}`}>
                  <td>{document.entity.company.company_config.name}</td>
                  <td>{document.entity.employee.employee_config.name}</td>
                  <td>{document.document_type.name}</td>
                  <td>{document.entity.start_date_to_s}</td>
                  <td>{document.entity.end_date_to_s || "Indefinido"}</td>
                  <td>{drawDeleteSelectedDocument(document)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <BulkRequestZipDocumentTable
        showDistributionListFilter={true}
        bulkRequest={bulkRequest}
        dataTableConfiguration={{
          columns: hiringDocumentsColumns
        }}
        tableConfirmDocument={tableConfirmDocument}
        configuration={{
          context: "laboral",
          defaultRequestParams: {},
        }}
        actions={{
          indexDocumentsPath: Routes.laboral_hiring_documents_path,
          createService: create,
          getDocumentByIds: getLaboralHiringDocumentByIds
        }}
        buttonActions={{
          show: Routes.laboral_bulk_request_zip_document_path,
          back: Routes.laboral_bulk_request_zip_documents_path(),
        }}
      />
    </div>
  );
};

export default LaboralBulkRequestZipDocumentForm;
